// extracted by mini-css-extract-plugin
export default {"responsive":"App_responsive__bLVCX"};